import type { TooltipProps } from 'recharts';
import type { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import type { ReactNode } from 'react';

interface Props extends TooltipProps<ValueType, NameType> {
  formatValue?: (v: number) => ReactNode;
}

export function ChartTooltip({ active, payload, label, formatValue }: Props) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-md border border-border bg-surface-elevated px-3 py-2 text-xs shadow-soft">
      {label != null ? <p className="mb-1 font-medium text-muted-foreground">{String(label)}</p> : null}
      <ul className="space-y-1">
        {payload.map((p, i) => {
          const num = Number(p.value);
          return (
            <li key={i} className="flex items-center justify-between gap-3">
              <span className="inline-flex items-center gap-1.5">
                <span
                  className="inline-block h-2 w-2 rounded-full"
                  style={{ backgroundColor: p.color as string }}
                  aria-hidden
                />
                <span className="text-muted-foreground">{p.name}</span>
              </span>
              <span className="kpi-num font-medium">
                {formatValue && Number.isFinite(num) ? formatValue(num) : String(p.value)}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
